import { useLayoutEffect } from "react";
import React, { useCallback, useEffect, useRef, useState } from "react";

import CostTableRow from "./CostTableRow";

// const StyledTableHeader = ({ children, ...props }) => (
//   <th
//     style={{
//       textTransform: "uppercase",
//     }}
//     {...props}
//   >
//     {children}
//   </th>
// );

const CostTable = ({ costs, slotDetails }) => {
  const [, setAdditionalRows] = useState(0);
  const tableRef = useRef();
  const [hasNoData, setHasNoData] = useState(false);

  // Check if there are any costs and set hasNoData accordingly
  useEffect(() => {
    setHasNoData(costs.length === 0);
  }, [costs]);

  const calculateAdditionalRows = useCallback(() => {
    if (hasNoData) {
      // No costs means we need to add additional rows
      const requiredRows = 8; // Maximum fake rows if no costs
      setAdditionalRows(requiredRows);
    } else {
      const costCount = costs.length;

      // Display additional rows based on the count of existing costs
      const rowsToShow = Math.max(0, 8 - costCount); // Calculate additional rows needed based on existing costs
      setAdditionalRows(rowsToShow);
    }
  }, [hasNoData, costs]);

  useEffect(() => {
    // Initial call to calculate additional rows
    calculateAdditionalRows();
    // Add resize event listener
    const handleResize = () => {
      calculateAdditionalRows();
    };
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [calculateAdditionalRows]);

  const rowRefs = useRef([]);
  const [rowHeight, setRowHeight] = useState(42);

  useLayoutEffect(() => {
    if (rowRefs.current.length) {
      const maxHeight = Math.max(
        ...rowRefs.current.filter(Boolean).map((el) => el.getBoundingClientRect().height)
      );
      setRowHeight(maxHeight);
    }
  }, [costs]);

  return (
    <div className="table--no-card rounded-0 border-0 w-100 min-h-382P58">
      <table
        ref={tableRef}
        className="table table-borderless table-striped  has-height-25 cost-table cost-table-alternate-colors"
        style={{ width: "100%" }}
      >
        <thead>
          <tr id="tb-header">
            <th
              className="text-center"
              style={{ minWidth: "25px", width: "25px", maxWidth: "25px" }}
            >
              {/* Index Header */}
            </th>
            <th className="text-center color-grey-2 requested-col">Requested</th>
            <th />
            <th className="text-center color-grey-2 payee-col">Payee</th>
            <th />
            <th className="text-center color-grey-2 memo-col">Memo</th>
            <th className="text-center color-grey-2 note-col">Note</th>
            <th />
            <th className="text-center color-grey-2 account-col">Account</th>
            <th className="text-center color-grey-2 invoice-col">Invoice</th>
            <th />
            <th className="text-center color-grey-2 amount-col">Amount</th>
            <th className="text-center color-grey-2 payment-col">Payment</th>
            <th style={{ minWidth: "15px", width: "15px", maxWidth: "15px" }} />
          </tr>
        </thead>
        <tbody>
          {costs.map((cost, index) => (
            <CostTableRow
              trRef={(el) => (rowRefs.current[index] = el)}
              idx={index}
              cost={cost}
              key={cost.id}
              slotDetails={slotDetails}
              rowHeight={rowHeight}
            />
          ))}
          {/* Render additional fake rows */}
          {<RenderAdditionalRows additionalRows={8 - costs?.length} rowHeight={rowHeight} />}
        </tbody>
      </table>
    </div>
  );
};

export const RenderAdditionalRows = ({ additionalRows, rowHeight = 25 }) => {
  return Array.from({ length: additionalRows }).map((_, rowIndex) => (
    <tr key={rowIndex} className="emptytestRows" style={{ height: `${rowHeight}px` }}>
      <td style={{ height: "35px", color: "transparent" }} colSpan={14} />
    </tr>
  ));
};

export default React.memo(CostTable);
